<template>
  <div class="lane-item-editor">
    <div class="row">
      <label>Label</label>
      <input
        type="text"
        v-model="item.label"
        :placeholder="labelPlaceholder"
        class="title"
        required />
    </div>
    <div class="row">
      <label>Description</label>
      <input
        type="text"
        v-model="item.description"
        placeholder="Description"
        class="description"
        required />
    </div>
    <div class="row">
      <label>Cost</label>
      <input
        type="number"
        v-model.number="item.cost"
        placeholder="Point cost" />
    </div>
    <div class="row">
      <label>Score</label>
      <input
        type="number"
        v-model.number="item.score"
        @change="dirtyScore = true"
        placeholder="Starting score" />
    </div>
    <div class="row restrictions">
      <label>Restrictions</label>
      <!-- <select v-model="item.requiresList" v-if="type !== 'upsell'">
        <option :value="true">Deck list required (1+ card)</option>
        <option :value="false">Deck list is optional</option>
      </select> -->
      <select v-model="item.tier">
        <option
          v-for="tier of subTiers"
          :key="tier.value"
          :value="tier.value"
          v-text="tier.label" />
      </select>

      <!-- Games constraints -->
      <template v-if="type === 'product' && template === 'games'">
        <!-- <label>Platforms</label>
        <div>
          <label v-for="platform of platforms" :key="platform.key">
            {{ platform.label }}
            <input type="checkbox" v-model="item.rules" :value="platform.key" />
            <br />
          </label>
        </div> -->
        <!-- <label>Platform</label>
        <select v-model="item.platform">
          <option :value="undefined">Any</option>
          <option v-for="platform of platforms" :key="platform.key" :value="platform.key" v-text="platform.label" />
        </select> -->
        <!-- <select
          v-if="type === 'product' && template === 'games'"
          class="deck-rules"
          v-model="item.rules"
          multiple>
          <optgroup label="Platforms">
            <option value="pc">PC</option>
            <option value="xbox-one">Xbox One</option>
            <option value="playstation4">PS4</option>
            <option value="nintendo-switch">Switch</option>
          </optgroup>
        </select> -->
      </template>

      <select v-if="type === 'product' && categorizedRules.length > 0" class="deck-rules" v-model="item.rules" multiple>
        <optgroup
          v-for="category of categorizedRules"
          :key="category.label"
          :label="category.label">
          <option
            v-for="rule of category.rules"
            :key="rule.key"
            :value="rule.key"
            v-text="rule.label" />
        </optgroup>
      </select>
    </div>
    <button
      @click="saveItem()"
      :disabled="!canSave"
      v-text="'Save'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LaneItemEdtior',
  props: ['value', 'type', 'template'],
  data () {
    return {
      item: { ...this.value },
      dirtyScore: false,
      subTiers: [
        { value: 0, label: 'Available to everyone' },
        { value: 1, label: 'Tier 1+ subs only' },
        { value: 2, label: 'Tier 2+ subs only' },
        { value: 3, label: 'Tier 3 subs only' }
      ],
      platforms: [
        { key: 'pc', label: 'PC' },
        { key: 'xbox1', label: 'Xbox One' },
        { key: 'ps4', label: 'PS4' },
        { key: 'switch', label: 'Nintendo Switch' },
        { key: 'wiiu', label: 'Wii U' },
        { key: 'xbox360', label: 'Xbox 360' },
        { key: 'ps3', label: 'PS3' },
        { key: 'wii', label: 'Wii' },
        { key: 'n64', label: 'N64' },
        { key: 'snes', label: 'Super NES' },
        { key: 'nes', label: 'NES' },
      ]
    }
  },
  watch: {
    'value' () {
      this.item = { ...this.value }
    },
    'item.cost' () {
      if (this.dirtyScore === false) {
        this.item.score = this.item.cost
      }
    }
  },
  computed: {
    ...mapState(['rules']),
    labelPlaceholder () {
      if (this.type === 'upsell') {
        return 'New add-on'
      }
      return 'New product'
    },
    canSave () {
      const { label, description, cost, score } = this.item
      // const keyCollision = this.items
      //   .some((item) => item !== this.selectedItem && item.key === key)
      if (!label || !description) return false
      if (isNaN(cost) || cost < 0) return false
      if (isNaN(score) || score < 0) return false
      // if (keyCollision) return false
      return true
    },
    categorizedRules () {
      const rules = this.rules
        .filter((r) => r.template === this.template)

      const categories = rules
        .reduce((a, { category: b }) => a.includes(b) ? a : a.concat(b), [])
      return categories.map((label) => ({
        label,
        rules: rules.filter((r) => r.category === label)
      }))

      const standardKeys = [
        'min60',
        'max250',
        'side0or15',
        'maxQuantity4'
      ]
      const colorKeys = [
        'noRed',
        'noGreen',
        'noBlue',
        'noBlack',
        'noWhite',
        'monoColor',
        'chromaColor'
      ]
      const stupidKeys = [
        'needHorse',
        'goodChristianSuburbs',
        'noice'
      ]
      const allKeys = [].concat(standardKeys, colorKeys, stupidKeys)

      return [
        {
          label: 'Standard',
          rules: rules.filter((r) => standardKeys.includes(r.key))
        },
        {
          label: 'Color Specific',
          rules: rules.filter((r) => colorKeys.includes(r.key))
        },
        {
          label: 'Miscellaneous',
          rules: rules.filter((r) => !allKeys.includes(r.key))
        },
        {
          label: 'Stupid',
          rules: rules.filter((r) => stupidKeys.includes(r.key))
        }
      ]
    }
  },
  methods: {
    saveItem () {
      this.$emit('saveItem', { ...this.item })
    }
  }
}
</script>

<style scoped>
.row {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: baseline;
  grid-gap: 0.5em;
  text-align: right;
}
.row + .row {
  margin-top: 1em;
}
.row select {
  width: 100%;
}
.deck-rules {
  height: 20em;
  font-size: 0.75em;
  grid-column: 1 / 3;
}
</style>
